export * from "./styles";

export const THEME_VARIANT = {
  DARK: "dark",
  LIGHT: "light",
};

export const TOKEN_STORAGE_KEY = "ac";
export const USER_CONFIG_STORAGE_KEY = "usc";
export const noop = () => {};
export const sessionExpireMsg =
  "Session expired! Redirecting to login screen..";
export const DEFAULT_ERROR_MESSAGE =
  "Something went wrong, please contact system administrator.";

export const PhoneRegexE164 = /^$|^\+\d{11,13}$/;

export const VALIDATIONS = {
  ALPHANUMERIC: "alphanumeric",
  MAX_LENGTH: "maxLength",
  MIN_LENGTH: "minLength",
  MAX: "max",
  MIN: "min",
  INTEGER: "integer",
  FLOAT: "float",
  NUMBER: "number",
  REQUIRED: "required",
  EMAILS: "emails",
  REGEX: "regex",
  PHONE: "phone",
};
export const PAGE_KEYS = {
  BROADCASTS: "broadcast",
  USER_PERMISSION: "user_permission",
  ADMIN_USER: "admin_user",
  ADMIN_WHITELIST: "admin_whitelist",
};

export const BROADCAST_STATUS = {
  SCHEDULED: "Scheduled",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  COMPLETED_WITH_ERROR: "Completed With Error",
  FAILED: 'Failed'
};

export const timezoneMapping = {
  "US/Mountain": "America/Denver",
  "US/Pacific": "America/Los_Angeles",
  "US/Central": "America/Chicago",
  "US/Eastern": "America/New_York",
};

export const ACCESS_DENIED_CODES = ["CMN-408", "BIL-101", "BIL-103"];

export const SUPPORTED_COUNTRIES = [
  {
    callingCode: '1',
    isoCode: 'US',
    name: 'United States',
    postalRegExp: /^[0-9]{5}$/,
  },
  {
    callingCode: '1',
    isoCode: 'CA',
    name: 'Canada',
    postalRegExp: /^[A-Z]{1}[0-9]{1}[A-Z]{1} [0-9]{1}[A-Z]{1}[0-9]{1}$/,
  },
  {
    callingCode: '33',
    isoCode: 'FR',
    name: 'France',
    postalRegExp: /^[0-9]{5}$/,
  },
  {
    callingCode: '44',
    isoCode: 'GB',
    name: 'United Kingdom',
    postalRegExp: /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/,
  },
  {
    callingCode: '61',
    isoCode: 'AU',
    name: 'Australia',
    postalRegExp: /^[0-9]{4}$/,
  },
];